import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '0',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '12px',
      alignItems: 'stretch',
    },
  },
  filtersContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
    },
  },
  filterSelect: {
    minWidth: '140px',
    height: '32px',
    backgroundColor: 'rgba(250, 250, 254, 1)',
    borderRadius: '4px',
    '& .MuiOutlinedInput-root': {
      height: '32px',
      borderRadius: '4px',
      backgroundColor: 'rgba(250, 250, 254, 1)',
      border: '1px solid rgba(233, 235, 245, 1)',
      '& fieldset': {
        border: '1px solid rgba(233, 235, 245, 1)',
      },
      '&:hover fieldset': {
        border: '1px solid rgba(233, 235, 245, 1)',
      },
      '&.Mui-focused fieldset': {
        border: '1px solid rgba(233, 235, 245, 1)',
      },
    },
    '& .MuiSelect-select': {
      padding: '6px 32px 6px 12px',
      fontSize: '14px',
      fontWeight: 400,
      color: 'rgba(27, 42, 71, 1)',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiSelect-icon': {
      color: 'rgba(120, 121, 142, 1)',
      right: '8px',
    },
  },
  filterDisplayText: {
    fontSize: '14px',
    fontWeight: 400,
    color: 'rgba(27, 42, 71, 1)',
  },
  clearFilterItem: {
    borderBottom: '1px solid rgba(233, 235, 245, 1)',
    marginBottom: '4px',
    paddingBottom: '8px',
    color: 'rgba(63, 81, 181, 1)',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: 'rgba(237, 231, 246, 0.3)',
    },
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-end',
      gap: '8px',
    },
  },
  downloadButton: {
    height: '32px',
    padding: '6px 16px',
    borderRadius: '4px',
    border: '1px solid rgba(63, 81, 181, 1)',
    color: 'rgba(63, 81, 181, 1)',
    backgroundColor: 'transparent',
    fontSize: '14px',
    fontWeight: 400,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      border: '1px solid rgba(63, 81, 181, 1)',
      boxShadow: 'none',
    },
  },
  downloadAllButton: {
    height: '32px',
    padding: '6px 16px',
    borderRadius: '4px',
    border: '1px solid rgba(63, 81, 181, 1)',
    color: 'rgba(63, 81, 181, 1)',
    backgroundColor: 'rgba(237, 231, 246, 1)',
    fontSize: '14px',
    fontWeight: 400,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'rgba(237, 231, 246, 1)',
      border: '1px solid rgba(63, 81, 181, 1)',
      boxShadow: 'none',
    },
  },
  tableWrapper: {
    marginTop: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  tableContainer: {
    width: '100%',
    overflowX: 'auto',
    border: '1px solid rgba(233, 235, 245, 1)',
    borderRadius: '4px',
    backgroundColor: '#fff',
  },
  table: {
    minWidth: 1620,
    borderCollapse: 'separate',
    borderSpacing: 0,
  },
  tableHead: {
    backgroundColor: 'rgba(250, 250, 254, 1)',
  },
  tableHeaderCell: {
    padding: '0 8px',
    height: '42px',
    fontSize: '12px',
    fontWeight: 500,
    color: 'rgba(69, 70, 83, 1)',
    borderBottom: '1px solid rgba(233, 235, 245, 1)',
    borderRight: '1px solid rgba(233, 235, 245, 1)',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    '&:last-child': {
      borderRight: 'none',
    },
  },
  sortIcon: {
    fontSize: '12px',
    marginLeft: '4px',
    color: 'rgba(120, 121, 142, 1)',
    verticalAlign: 'middle',
    display: 'inline-flex',
    alignItems: 'center',
  },
  tableBody: {
    backgroundColor: '#fff',
  },
  tableRow: {
    height: '48px',
    '&:hover': {
      backgroundColor: 'rgba(250, 250, 254, 0.5)',
    },
  },
  tableCell: {
    padding: '0 8px',
    height: '48px',
    fontSize: '12px',
    fontWeight: 400,
    color: 'rgba(95, 96, 113, 1)',
    borderBottom: '1px solid rgba(233, 235, 245, 1)',
    borderRight: '1px solid rgba(233, 235, 245, 1)',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    '&:last-child': {
      borderRight: 'none',
    },
  },
  checkboxCell: {
    width: '48px',
    minWidth: '48px',
    maxWidth: '48px',
    padding: '0',
    textAlign: 'center',
    justifyContent: 'center',
  },
  downloadIconCell: {
    width: '48px',
    minWidth: '48px',
    maxWidth: '48px',
    padding: '0',
    textAlign: 'center',
    justifyContent: 'center',
  },
  dataCell: {
    width: '126px',
    minWidth: '126px',
    maxWidth: '126px',
  },
  downloadIcon: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    color: 'rgba(63, 81, 181, 1)',
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    borderTop: '1px solid rgba(233, 235, 245, 1)',
    backgroundColor: '#fff',
  },
  paginationLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  paginationRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  paginationLabel: {
    fontSize: '12px',
    color: 'rgba(95, 96, 113, 1)',
  },
  paginationSelect: {
    height: '24px',
    minHeight: '24px',
    fontSize: '12px',
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-root': {
      height: '24px',
      minHeight: '24px',
    },
    '& .MuiSelect-select': {
      padding: '2px 24px 2px 8px',
      fontSize: '12px',
      lineHeight: '20px',
    },
    '& .MuiSelect-icon': {
      fontSize: '16px',
    },
  },
  paginationInput: {
    width: '40px',
    height: '24px',
    fontSize: '12px',
    padding: '2px 4px',
    border: '1px solid rgba(233, 235, 245, 1)',
    borderRadius: '4px',
    textAlign: 'center',
    '& input': {
      textAlign: 'center',
      padding: '0',
      fontSize: '12px',
    },
  },
  paginationButton: {
    minWidth: '24px',
    width: '24px',
    height: '24px',
    padding: '0',
    fontSize: '12px',
    color: 'rgba(95, 96, 113, 1)',
    '&:disabled': {
      color: 'rgba(198, 199, 209, 1)',
    },
    '& .MuiTypography-root': {
      fontSize: '12px',
      lineHeight: '1',
    },
  },
  loader: {
    color: '#1976d2', // Blue color for Material-UI v4 primary blue
    marginLeft: '8px',
  },
  filterPopper: {
    borderRadius: 10,
    boxShadow: '0 10px 19.6px 0 #E7E8EB',
    zIndex: 1000,
    maxHeight: 'calc(100vh - 570px)',
    overflow: 'auto',
    '@media (max-width: 1280px)': {
      maxHeight: 'calc(100vh - 400px)',
    },
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100vh - 350px)',
    },
  }
}));

export default useStyles;

